// Dealing with bleed components that have backgrounds to remove space between them.
export default () => {
  document.querySelectorAll(".container--bleed").forEach((el) => {
    if (
      el.querySelector(".has-background:last-child") ||
      el.querySelector(".has-bottom-background:last-child")
    ) {
      el.classList.add("contains-last-background");
    }
    if (el.querySelector(".has-background:first-child")) {
      el.classList.add("contains-first-background");
    }
  });

  // Hero is in a 100 container add should have this logic applied
  document.querySelectorAll(".container--100").forEach((el) => {
    if (el.querySelector(".hero.has-bottom-background:last-child") || el.querySelector(".hero-slider-container:last-child")) {
      el.classList.add("contains-last-background");
    }
  });
};
